import { AnnotationActivationMessage, AnnotationReleaseMessage } from '@augloop/session-protocol';
export class AnnotationActivationTracker {
    constructor(sendMessage, annotationType, options) {
        this.sendMessage = sendMessage;
        this.annotationType = annotationType;
        this.options = options;
        this.token = `${annotationType}-${AnnotationActivationTracker.nextActivationResultBatchId++}`;
    }
    activate(ignoreExistingAnnotations, sendOnlyIfConnected) {
        return new Promise((resolve, reject) => {
            this.sendMessage(new AnnotationActivationMessage({
                annotationType: this.annotationType,
                token: this.token,
                config: this.options ? this.options.config : undefined,
                ignoreExistingAnnotations: ignoreExistingAnnotations,
                sendStateUpdates: this.options ? !!this.options.stateUpdateCallback : undefined,
                forceReturnCachedAnnotations: this.options ? this.options.forceReturnCachedAnnotations : undefined
            }), (error, _response) => {
                if (error) {
                    reject(new Error(error.error));
                }
                else {
                    resolve({ token: this.token });
                }
            }, sendOnlyIfConnected);
        });
    }
    release() {
        return new Promise((resolve, reject) => {
            this.sendMessage(new AnnotationReleaseMessage({ token: this.token }), (error, response) => {
                if (error) {
                    reject(new Error(error.error));
                }
                else {
                    resolve(response.lastRelease);
                }
            });
        });
    }
}
AnnotationActivationTracker.nextActivationResultBatchId = 1;
//# sourceMappingURL=annotation-activation-tracker.js.map